var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('./../../template/msg/card-msg-evaluate2.html');
var config = require('../../global/config');
var ActionType = require('../../constant/ActionType'); 
var dispatcher = require('../../global/dispatcher');

var CardMsgEvaluate2 = function (options) {
    (function(self){
        var defaults ={
            template:template
        };
        $.extend(defaults,options);
        BaseMsgItem.call(self,defaults);
        let inputDiv =self._element.find('.im-evaluate2-input');
        inputDiv.keydown(()=>{
            let len = inputDiv.val().length
            if(len>140){
                inputDiv.attr("readonly","readonly")
                var text = '超过可输入的最大字符数，请重新输入！';
                dispatcher.dispatch({
                    type: ActionType.TOAST_SHOW,
                    data: {
                        content: text,
                        interval: 2000
                    }
                }); 
            }
        })
    })(this);
};
//渲染星星函数
const getStar=({starNum,activeNum})=>{
    let fragment = $('<div></div>')

    for(let i=0;i<starNum;i++){
        let $span = $('<span></span>');
        $span.addClass('star-content-span')
        $span.attr('starIndex',i)
        i==starNum-1 && $span.addClass('last-star')
        if(i<activeNum){
            $span.addClass('star-active')
        }
        fragment.append($span);
    }
      return fragment;
}
    //渲染标签
const getEvalDiv=(content,current,tagContent)=>{
    let labels= content.options[current].labels;
    let len = labels.length;
    if(len === 1 || len%3 === 2){  
        tagContent.addClass('center');
    }else{
        tagContent.removeClass('center')
    }
    return labels.map((text,index)=>{
        return `<div class="tag-content-div${index==2?' last-tag':''}" title=${text}>${text}</div>`
    }).join('')
}

CardMsgEvaluate2.prototype = Object.create(BaseMsgItem.prototype);
CardMsgEvaluate2.prototype.renderContent = function () {
  var self = this;
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  //数据
  var content = msg.content;
  let evalData =JSON.parse(JSON.stringify(content))
  var element = this._element;
  let starStatus;
  if(evalData && !evalData.options){
      return false
  }
//获取dom
const starContent = element.find('.star-content');
const titleDiv = element.find('.im-evaluate2-title');
const titleDiv2 = element.find('.im-evaluate2-title2');
const sendBtn = element.find('.send-content');
const smileContent = element.find('.smile-content');
const tagContent = element.find('.tag-content');
const inputContent = element.find('.input-content');

//提交
const sendHandle =(e)=>{
    e.stopPropagation();
    let config;
    if(evalData.options.length<5){
        let selectedIdx=element.find('.smile-content').find('.active').attr('smile-idx')
        config=evalData.options.find(item=>item.idx==selectedIdx)
    }else{
        config=evalData.options.find(item=>item.idx==starStatus)
    }
    if(!config){
        return
    }
    config.level = starStatus+1;
    let selectedLabelDom=tagContent.find('.tag-active')
    let selectedLabel=[]
    selectedLabelDom.each(function(index,element){
        selectedLabel.push(element.innerText.trim())
    })
    let inputValue =inputContent.find(".im-evaluate2-input").val()
    if(config.remark_info && config.remark_info.required === 1){//必须填写补充评价
        if(inputValue === ""){
            //提示必须填写补充评价
            var text = '写一下您的宝贵意见吧！';
                dispatcher.dispatch({
                    type: ActionType.TOAST_SHOW,
                    data: {
                        content: text,
                        interval: 2000
                    }
                }); 
            return 
        }
    }
    if(config.labels_required && config.labels_required ===1){//标签必须填写
        if(selectedLabel===[]){//提示必须填写补充评价
            var text = '至少选择一个标签';
                dispatcher.dispatch({
                    type: ActionType.TOAST_SHOW,
                    data: {
                        content: text,
                        interval: 2000
                    }
                }); 
            return 
        }
    }
    let evaluateResult={//评价结果
        "extra":evalData.extra,//可选字段，业务侧透传信息
        "selected_option":{//用户选择的选项及对应标签
            "title":config.title,
            "idx":config.idx,
            "labels":selectedLabel,
            "level":config.level, //该选项表示的评价等级，五星表示[1-5]
            "remark":'' || inputValue//可选，用户添加的补充评价
        }
    } 
    //评价结果字段
    let sendMsg={ 
        "msg_id":msg.msg_id,//评价消息卡片的msg_id
        "sender_id":msg.sender_id,//评价卡片消息的其他字段
        "sender_source":msg.sender_source,
        "to_id":msg.to_id,
        "to_source":msg.to_source,
        "show_type":evalData.type,
        "bus_scene":evalData.bus_scene,//业务场景，不同业务场景的评价结果可能会方到不同的消息总线，业务侧通过消息总线监听结果。
        "result":evaluateResult
    }
    let updateMsg = JSON.parse(JSON.stringify(msg))
    updateMsg.content.result=evaluateResult;
    let evaluateMsg = {
        sendMsg:sendMsg,
        updateMsg:updateMsg
    }
    dispatcher.dispatch({
        type: ActionType.SET_EVALUATE,
        data: evaluateMsg
    });
    sendBtn.text("感谢您的评价，这将帮助我们做得更好");
    sendBtn.css('color','rgba(153,153,153,1)')
    sendBtn.off('click',sendHandle)
    starContent.off('click',starBoxHandle)
    smileContent.off('click',smileHandle)
    tagContent.off('click',labelHandle)
    element.find('.im-evaluate2-input').attr("disabled","disabled")
};
//点击星星事件
const starBoxHandle=(event)=>{
    event.stopPropagation();
    var $clickDom = $(event.target) || $(window.event.srcElement)
    //判断点击的dom 是不是星星 不是的话 不做处理
    if(! $clickDom.hasClass('star-content-span')){
        return false
    }
    let index =parseInt($clickDom.attr('starIndex'))
    let $starItems = $clickDom.parent().children();
    starStatus = index;
    let len = $starItems.length;
    for(let i=0;i<len;i++){
        $($starItems[i]).removeClass('star-active')
        if(i<index+1){
            $($starItems[i]).addClass('star-active')
        }
    }
    //提交 
    sendBtn.css('color','rgba(33, 187, 247, 1)');
    //是否有标签
    let addEvalHtml = getEvalDiv(content,index,tagContent);
    tagContent.html(addEvalHtml)
    //是否为补充评价
    if(evalData.options[index].remark_info){
        inputContent.css('display','flex')
    } else{
        inputContent.css('display','none')
    }
}
//点击笑脸事件
const smileHandle=(event)=>{
    event.stopPropagation();
    //判断点击的dom
    var $clickDom = $(event.target) || $(window.event.srcElement)
    if(typeof($clickDom.attr("smile-idx"))=="undefined") {
        return false
    }
    let index=parseInt($clickDom.attr('smile-idx'))
    //清除当前的状态
    let $emojiBoxs = $clickDom.parent().parent().children()
    let len = $emojiBoxs.length;
    for(let i=0;i<len;i++){
        $($emojiBoxs[i]).removeClass('active')
        if(i == index){
            $($emojiBoxs[i]).addClass('active')
        }
    }
    starStatus =0;
    //提交 
    sendBtn.css('color','rgba(33, 187, 247, 1)');
    //是否有标签
    let addEvalHtml = getEvalDiv(content,index,tagContent);
    tagContent.html(addEvalHtml)
    //是否需要补充评价
    if(evalData.options[index].remark_info){
        inputContent.css('display','flex')
    } else{
        inputContent.css('display','none')
    } 
}
//点击标签
const labelHandle=(event)=>{
    event.stopPropagation();
    let $labelActive = $(event.target) || $(window.event.srcElement)
    if(!$labelActive.hasClass('tag-content-div')){
        return false
    }
    
    if($labelActive.hasClass('tag-active')){
        $labelActive.removeClass('tag-active')
    }else{
        $labelActive.addClass('tag-active')
    }
}
    //渲染title
    let titleText = evalData.title ?evalData.title:''
    titleDiv.text(titleText);
    titleDiv2.text("匿名评价,请放心填写");
    if(evalData.status === 0){//没有评价
        //渲染评价区域:如果是笑脸评价
        if(evalData.options && evalData.options.length !==0){
            let len = evalData.options.length
            let classNames;
            
            if(len<5){//笑脸表情  2  3
                if(len==2){
                    classNames=['good-smile','bad-smile']
                }else if(len==3){
                    classNames=['good-smile','ok-smile','bad-smile']
                }else{
                    classNames=[]
                }
                let domString = evalData.options.map((item,index)=>{
                    return `<div class="${classNames[item.idx]} emojiBox" smile-idx="${item.idx}"><span  smile-idx="${item.idx}"></span><span smile-idx="${item.idx}">${item.title}</span></div>` 
                }).join('')
                smileContent.html(domString) 
            }else{ //5星好评,显示星级
                let starHtml = getStar({starNum:5,activeNum:0})
                starContent.append(starHtml)
            }
        }else{ //评价指标为空
            return
        }
        //绑定事件
        starContent.on('click',starBoxHandle)
        smileContent.on('click',smileHandle)
        sendBtn.on('click',sendHandle);
        tagContent.on('click',labelHandle)
    }else{//已经评价，根据结果来渲染
        //数据处理
        if( evalData && !evalData.result){
            return false
        }
        let evalDataLen = evalData.options && evalData.options.length;
        let resData = evalData.result.selected_option ? evalData.result.selected_option:{};

        if(!resData.title){//，没有title的处理
            resData.title = ''
        }
        let smileIndex = resData.idx ? resData.idx:0;
        //输入框
        let inputDiv = element.find('.im-evaluate2-input');
        if(resData.remark){
            inputContent.css('display','flex')
            inputDiv.remove()
            inputContent.append($('<div class = "im-input-has-evaluate"></div>').text(resData.remark))
            // inputDiv.attr("value",resData.remark);
            // inputDiv.attr("disabled","disabled");       
        }else{
            inputContent.hide();
        }
        let classNames;
        if(evalDataLen >=5){//是否为星级评价
            let starHtml= getStar({starNum:5,activeNum:resData.level});
            starContent.append(starHtml);
            smileContent.hide();
        }else{
            //笑脸
            if(evalDataLen === 2){
                classNames=['good-smile','bad-smile']
            }else if(evalDataLen === 3){
                classNames=['good-smile','ok-smile','bad-smile']
            }else{//其他情况直接退出
                return
            }
            smileContent.addClass('result')
            let EmojiDomStringResult=` <div class="${classNames[smileIndex]} emojiBox active" smile-idx="${smileIndex}"><span  smile-idx="${smileIndex}"></span><span  smile-idx="${smileIndex}">${resData.title}</span></div>` 
            smileContent.html(EmojiDomStringResult)
            starContent.hide() 
        }
         //tag
        let labelData = resData.labels ? resData.labels:[];
        if(labelData.length === 0){
            tagContent.hide();
        }else{
            if(labelData.length === 1 || labelData.length%3 === 2){
                tagContent.addClass('center');
            }
            let labelDomStringResult = labelData.map((item)=>{
                return `<div class="tag-content-div tag-active" title=${item}>${item}</div>`
            }).join('')
            tagContent.addClass('result')
            tagContent.html(labelDomStringResult);
        }
        
         //提交
        sendBtn.text("感谢您的评价，这将帮助我们做得更好");
        sendBtn.css('color','rgba(153,153,153,1)')
    }
};

module.exports = CardMsgEvaluate2;